import { StatusSelectController } from './status-select.controller'

function statusSelectDirective () {
  return {
    restrict: 'E',
    scope: {
      options: '=',
      value: '=',
      onChange: '=',
      isSubtask: '<',
      readOnly: '<'
    },
    templateUrl: '/workflow/directives/status-select/status-select-directive.html?$$REVISION$$',
    controller: StatusSelectController
  }
}

export { statusSelectDirective }
